(function () {
  if (window.__AG_PB_TIMELINE_INIT__) return;
  window.__AG_PB_TIMELINE_INIT__ = true;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getSteps(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-timeline-step'));
  }

  function updateProgress(root) {
    var steps = getSteps(root);
    var fill = root.querySelector('.js-ag-pb-timeline-fill');
    var track = root.querySelector('.ag-pb-timeline__track');
    if (!fill || !track || steps.length === 0) return;

    var markers = steps.map(function (step) {
      return step.querySelector('.js-ag-pb-timeline-marker');
    }).filter(Boolean);

    if (markers.length === 0) return;

    var layout = root.querySelector('.ag-pb-timeline__layout');
    if (!layout) return;

    var layoutRect = layout.getBoundingClientRect();
    var firstRect = markers[0].getBoundingClientRect();
    var lastRect = markers[markers.length - 1].getBoundingClientRect();
    var firstCenter = firstRect.top + firstRect.height / 2;
    var lastCenter = lastRect.top + lastRect.height / 2;
    var trackSpan = Math.max(0, lastCenter - firstCenter);

    track.style.top = Math.max(0, firstCenter - layoutRect.top) + 'px';
    track.style.bottom = 'auto';
    track.style.height = trackSpan + 'px';

    var triggerY = window.innerHeight * 0.58;
    var activeIndex = -1;

    steps.forEach(function (step, index) {
      var marker = markers[index];
      if (!marker) return;
      var rect = marker.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      if (center <= triggerY) activeIndex = index;
    });

    if (prefersReducedMotion()) {
      activeIndex = steps.length - 1;
      steps.forEach(function (step) {
        step.classList.add('is-visible');
      });
    }

    steps.forEach(function (step, index) {
      var isActive = index <= activeIndex;
      step.classList.toggle('is-active', isActive);
      if (isActive) step.classList.add('is-visible');
    });

    if (activeIndex < 0) {
      fill.style.height = '0px';
      return;
    }

    var activeRect = markers[activeIndex].getBoundingClientRect();
    var activeCenter = activeRect.top + activeRect.height / 2;
    var fillHeight = Math.max(0, Math.min(trackSpan, activeCenter - firstCenter));
    fill.style.height = fillHeight + 'px';
  }

  function initBlock(root) {
    if (root.dataset.agPbTimelineReady === 'true') return;
    root.dataset.agPbTimelineReady = 'true';

    var ticking = false;

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateProgress(root);
        ticking = false;
      });
    }

    updateProgress(root);
    requestAnimationFrame(function () {
      updateProgress(root);
    });

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        updateProgress(root);
      });
      document.addEventListener('shopify:block:select', function () {
        updateProgress(root);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-timeline').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
